/**
 * PricingSection - Markup and discount options
 *
 * Wraps existing PricingOptions for mobile/tablet display
 * On large screens, this is shown in the sidebar instead
 */

import { useTranslation } from "react-i18next";
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { PricingOptions } from "@/components/quotes/PricingOptions";
import { centsToDollars } from "@/lib/price-utils";
import { QuoteFormData, TemplateFormData } from "../index";

interface PricingSectionProps {
  form: UseFormReturn<QuoteFormData | TemplateFormData>;
  subtotalBeforeDiscount: number; // in cents
}

export const PricingSection: React.FC<PricingSectionProps> = ({
  form,
  subtotalBeforeDiscount,
}) => {
  const { t } = useTranslation();
  return (
    <div className="border-t pt-6 xl:hidden">
      <h3 className="text-lg font-medium mb-4">{t("features.quotes.quoteEditor.sections.pricingSection.pricingOptions")}</h3>
      <PricingOptions
        markupPercent={form.watch("markupPercent") ?? 0}
        onMarkupPercentChange={(value) =>
          form.setValue("markupPercent", value, {
            shouldValidate: true,
            shouldDirty: true,
          })
        }
        discountPercentage={form.watch("discountPercentage") ?? 0}
        onDiscountPercentageChange={(value) =>
          form.setValue("discountPercentage", value, {
            shouldValidate: true,
            shouldDirty: true,
          })
        }
        discountDescription={form.watch("discountDescription") ?? ""}
        onDiscountDescriptionChange={(value) =>
          form.setValue("discountDescription", value, {
            shouldValidate: true,
            shouldDirty: true,
          })
        }
        totalAmount={centsToDollars(subtotalBeforeDiscount)}
      />
    </div>
  );
};
